import React from "react"
import PropTypes from "prop-types"
import _ from "lodash"
import { getMessage } from "@/utils/MessageUtils"

class PotentialStatus extends React.Component {
  static propTypes = {
    potentialStatus: PropTypes.string,
    transactionProbability: PropTypes.number,
  }

  render() {
    const { potentialStatus, transactionProbability } = this.props
    if (!potentialStatus) {
      return null
    }
    return <span>{getMessage(potentialStatus + "-" + transactionProbability, "MixedPotentialStatus")}</span>
  }
}

export default PotentialStatus
